// bank-misc-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1b.guided.useStatementAmount': 'Usar el importe del extracto ({amount})',
  'r1b.guided.checkedSuggestions': '{count} propuestas revisadas',
  'r1b.import.read': 'Leído: {amount}',
  'r1b.misc.bankAmountIncl': 'Importe bancario con {vat}',
  'r1b.misc.bankAmountExcl': 'Importe bancario sin {vat}',
  'r1b.misc.invoiceOption': '{number} · {customer} · pendiente {remaining}',
  'r1b.posting.view': 'Ver',
  'r1b.inbox.uploadingAnalysing': 'Subiendo y analizando',
  'r1b.surface.statementArchived': 'El extracto bancario se ha conciliado y archivado',
  'r1b.surface.archiveFailed': 'No se pudo archivar el extracto bancario',
  'r1b.route.loadFailed': 'No se pudo cargar la página.',
  'r1b.route.loading': 'Cargando la página...',
});
